module.exports = __webpack_public_path__ + "static/media/14C.edc0e599.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/14C.svg
// module id = 49
// module chunks = 0